export default (opts = {}) => {
  const block = {
    id: "title4",
    label: "H4",
    fromPlugin: 'title',
    apper : 'out', 
    media: '<i class="bi bi-type-h4"></i>', 
    content: { type: "title4" },
  };

  return block;
};



